import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'
import loadmore from './select/loadmore'


const install = function (Vue) {
    Vue.directive('hasRole', hasRole)
    Vue.directive('hasPermi', hasPermi)
    Vue.directive('loadmore', loadmore)
}

if (window.Vue) {
    window['hasRole'] = hasRole
    window['hasPermi'] = hasPermi
    Vue.use(install); // eslint-disable-line
}

export default install
